<script context="module">
    import { derived, get } from "svelte/store";
    import store, { currentSegment } from "./quiz-store";
    import eventLogger from "./quiz-event-logger";

    let prevSegmentId;

    const sequenceState = derived(store, ($) => {
        if ($ == null) {
            return;
        }
        return {
            segment: $.segment,
            step: $.step,
        };
    });

    currentSegment.subscribe(($) => {
        if ($ == null) {
            return;
        }
        if (prevSegmentId === $.value.id) {
            return;
        }
        eventLogger.logEvent("level_start", {
            level_number: $.idx + 1,
            level_id: $.value.id,
        });
        prevSegmentId = $.value.id;
    });

    sequenceState.subscribe(($) => {
        if ($ == null) {
            return;
        }
        const { segment, step } = $;
        if (step.next == null) {
            eventLogger.logEvent("level_end", {
                level_number: segment.idx + 1,
                level_id: segment.value.id,
            });
        }
        if (step.next == null && segment.next == null) {
            eventLogger.logEvent("game_end");
        }
    });

    export function handleSelectOption(option) {
        const answerId = option.answerId;
        if (option.answerId != null) {
            store.update((s) => {
                if (s.score[answerId] == null) {
                    s.score[answerId] = 0;
                }
                ++s.score[answerId];
                return s;
            });
        }

        goToNextStep();
    }

    export function goToNextStep() {
        const state = get(store);

        eventLogger.logEvent("step_forward", {
            step_number: state.globalStepIdx + 1,
        });

        store.update((store) => {
            ++store.globalStepIdx;

            let nextStep = store.step.next;
            if (nextStep == null) {
                const nextSegment = store.segment.next;
                store.segment = nextSegment;
                nextStep = nextSegment.value.steps.head;
            }

            store.step = nextStep;

            return store;
        });
    }

    export function calculateResult(segmentId) {
        const state = get(store);
        console.log(`--- finalScore:`, state.score);

        let winningAnswerIds = [];
        let high = 0;
        for (const [answerId, count] of Object.entries(state.score)) {
            switch (true) {
                case count === high:
                    winningAnswerIds.push(answerId);
                case count > high:
                    winningAnswerIds = [answerId];
                    high = count;
            }
        }

        const winningAnswerId = winningAnswerIds[0];
        const segmentConfig = state.config.segments[segmentId];
        const winner = segmentConfig.results[winningAnswerId];
        const discountUrl = `/discount/${winner.discount_code}?redirect=${winner.redirect_url}`;

        eventLogger.logEvent("result", {
            answer_id: winningAnswerId,
            discount_code: winner.discount_code,
            redirect_url: discountUrl,
        });

        return {
            discountUrl,
        };
    }
</script>
